export enum ScimSourceType {
  OKTA = 'okta',
  AZURE_AD = 'azure-ad',
  OTHER = 'other',
}

export enum ScimConfigStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
}

export type ScimConfig = {
  name: string;
  provisioning_url: string;
  source: ScimSourceType;
  status: ScimConfigStatus;
};

export type CreateScimRequest = {
  source: ScimSourceType;
};

export type CreateScimResponse = {
  provisioning_url: string;
  token: string;
};
